import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { EventId } from 'src_common/common/websocket2/id/WebsocketId';
import {
    RaceSummaryRowMarkets,
    RaceSummaryRowMarketsConfigType,
} from './templates/rowMarkets/summaryMarkets/RaceSummaryRowMarkets';
import { RaceSummaryBettingWithoutState } from 'src/domains/sportsbook/webview/components/raceSummary/RaceSummaryBettingWithout.state';
import { RowMarketsState } from 'src/domains/sportsbook/webview/components/raceSummary/templates/rowMarkets/summaryMarkets/RaceSummaryRowMarkets.state';

const viewConfig: RaceSummaryRowMarketsConfigType = {
    displayShowMoreButton: false,
    withTableHeader: true,
};

export interface RaceSummaryBettingWithoutPropsType {
    eventId: EventId;
}

export const RaceSummaryBettingWithout = observer(
    'RaceSummaryBettingWithout',
    (props: RaceSummaryBettingWithoutPropsType) => {
        const [state] = useState(() => new RowMarketsState(new RaceSummaryBettingWithoutState(props.eventId)));

        return (
            <RaceSummaryRowMarkets
                state={state}
                eventId={props.eventId}
                config={viewConfig}
            />
        );
    }
);
